<script setup lang="ts">
  import type { RefundStatusDictionaryRecord } from '@storefront/resources';

  interface Props {
    status: RefundStatusDictionaryRecord;
  }

  defineProps<Props>();
</script>

<template>
  <span class="refund-status" :class="status.class">
    {{ status.label }}
  </span>
</template>

<style lang="scss">
  :root {
    --refund-status-label-color: var(--color-default);
    --refund-status-label-background: var(--color-secondary);
    --refund-status-label-radius: 0.625rem;
    --refund-status-label-font-size: 0.75rem;
    --refund-status-label-padding-y: 0.25rem;
    --refund-status-label-padding-x: 0.75rem;

    --refund-status-label-color-info: var(--sf-status-color-info);
    --refund-status-label-background-info: var(--sf-status-background-info);
    --refund-status-label-color-danger: var(--sf-status-color-danger);
    --refund-status-label-background-danger: var(--sf-status-background-danger);
    --refund-status-label-color-warning: var(--sf-status-color-warning);
    --refund-status-label-background-warning: var(--sf-status-background-warning);
    --refund-status-label-color-success: var(--sf-status-color-success);
    --refund-status-label-background-success: var(--sf-status-background-success);
  }

  .refund-status {
    display: inline-block;
    background-color: var(--refund-status-label-background);
    color: var(--refund-status-label-color);
    border-radius: var(--refund-status-label-radius);
    font-size: var(--refund-status-label-font-size);
    padding: var(--refund-status-label-padding-y) var(--refund-status-label-padding-x);
    font-weight: var(--font-weight-bold);

    &.waiting-for-response {
      background: var(--refund-status-label-background-info);
      color: var(--refund-status-label-color-info);
    }

    &.waiting-for-product {
      background: var(--refund-status-label-background-warning);
      color: var(--refund-status-label-color-warning);
    }

    &.completed {
      background: var(--refund-status-label-background-success);
      color: var(--refund-status-label-color-success);
    }

    &.rejected {
      background: var(--refund-status-label-background-danger);
      color: var(--refund-status-label-color-danger);
    }
  }
</style>
